// @ts-nocheck
import { PaymentProcessor } from 'shovel-lib/types';
import { gtmId } from './configConstants';
import { roundNumber } from '@components/common/onboardingBar/helpers';
import { reportAction } from '../api/activityLogApi';

const USE_GTM = !!gtmId;

let loaded = false;

const initializeAnalytics = () => {
  if (USE_GTM && !loaded) {
    includeGtmScript();
    loaded = true;
  } else {
    console.log('.setupAnalytics()');
  }
};

const identifyUser = (userId: number, organizationId?: number) => {
  if (USE_GTM) {
    window.dataLayer.push({
      userId: userId.toString(),
      organizationId
    });
  } else {
    console.log(`.identifyUser(userId: ${userId}, organizationId: ${organizationId})`);
  }
};

// GA events that are also something only the web app sees, passed on to Shovel's activity log under its own name.
// Everything else the student does is logged by the backend itself, so it must not be forwarded.
const FORWARDED = {
  complete_demo: 'demo_completed'
};

const track = (event: string, params?: any) => {
  if (FORWARDED[event]) reportAction(FORWARDED[event]);
  const props = params ? { eventProps: params } : {};
  if (USE_GTM) {
    window.dataLayer.push({
      event: event,
      ...props
    });
  } else {
    console.log(`.track(event: ${event}, params: ${JSON.stringify(props)})`);
  }
};

const base64Encode = (value: string) => btoa(value);

// <!-- Google Tag Manager -->
const includeGtmScript = () => {
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    const f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', gtmId);

  window.dataLayer = window.dataLayer || [];
};

export const AnalyticsEvent = {
  Registration: {
    name: 'sign_up',
    params: (organizationId?: number) => ({
      organizationId
    })
  },
  MobileRegistration: {
    name: 'sign_up_mobile',
    params: (organizationId?: number) => ({
      organizationId
    })
  },
  CancelSubscription: {
    name: 'cancel_subscription'
  },
  DeleteAccount: {
    name: 'delete_account',
    params: (trialLeft: number) => ({
      trialLeft
    })
  },
  Subscribe: {
    name: 'begin_checkout',
    params: (processor: PaymentProcessor, plan: string, coupon?: string) => ({ processor, plan, coupon })
  },
  CompleteTask: {
    name: 'complete_task',
    // source: where it was ticked off - 'task_list' for the Task List's ring; absent from the task popup's button, which
    // was the only place that counted before (2026-10).
    params: ({
      completedOn,
      due,
      estimatedTime,
      timePlanned,
      timeStillNeed,
      source
    }: {
      completedOn: string;
      due?: string;
      timePlanned?: number;
      timeStillNeed: number;
      estimatedTime: number;
      source?: 'task_list';
    }) => ({
      completedOn,
      due,
      timePlanned,
      estimatedTime,
      timeStillNeed,
      source
    })
  },
  PlanTask: {
    name: 'plan_task',
    params: (days_before_due: number, days_after_start: number) => ({
      daysBeforeDue: roundNumber(days_before_due, 0),
      daysFromStart: roundNumber(days_after_start, 0)
    })
  },
  CreateTask: {
    name: 'create_task',
    params: (total: number) => ({ total })
  },
  StartTimer: {
    name: 'start_timer'
  },
  CreateEvent: {
    name: 'create_event'
  },
  CompleteDemo: {
    name: 'complete_demo'
  },
  QuickSetup: {
    TimeZone: {
      name: 'complete_setup_time_zone'
    },
    TermDates: {
      name: 'complete_setup_term_dates'
    },
    Holidays: {
      name: 'complete_setup_holidays'
    },
    AwakeTime: {
      name: 'complete_setup_awake_time'
    },
    Courses: {
      name: 'complete_setup_courses'
    },
    Activities: {
      name: 'complete_setup_activities'
    }
  },
  ResetTrial: {
    name: 'reset_trial'
  },
  RedeemAccess: {
    name: 'redeem_access'
  }
};

export default {
  initializeAnalytics,
  identifyUser,
  track
};
